import React from "react";
import PropTypes from "prop-types";

import {
  DeletedCRMContactWarning,
  Name,
  ReminderItem,
  Spinner,
  usePrivacyMode,
  UserAvatar,
} from "./components";

export function ReminderTile({ reminder, spinning }) {
  const { piiMask } = usePrivacyMode();

  const { title, dismissed, completedAt, time, task, client } = reminder;
  const { assignee } = task || {};

  return (
    <React.Fragment>
      <ReminderItem
        title={title}
        time={time}
        completed={Boolean(completedAt || dismissed)}
        clientNameSlot={
          client && (
            <Name
              fullName={`${client.firstName} ${client.lastName}`}
              suffixClassName={piiMask("fs-block dd-privacy-mask")}
            />
          )
        }
      >
        <Spinner active={spinning} />
        {!spinning && client && (
          <div style={{ marginTop: "1.2em" }}>
            <DeletedCRMContactWarning
              show={client.isDeletedInCrm}
              offset="10px,0"
              position="top right"
            />
          </div>
        )}
        {assignee && !spinning && <UserAvatar user={assignee} size="large" />}
      </ReminderItem>
    </React.Fragment>
  );
}

ReminderTile.propTypes = {
  reminder: PropTypes.shape({
    title: PropTypes.string.isRequired,
    time: PropTypes.string.isRequired,
    dismissed: PropTypes.bool.isRequired,
    completedAt: PropTypes.string,
    client: PropTypes.shape({
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      isDeletedInCrm: PropTypes.bool,
    }),
    task: PropTypes.shape({
      assignedAdvisor: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }),
    }),
  }).isRequired,
  spinning: PropTypes.bool,
};

ReminderTile.defaultProps = {
  spinning: false,
};

export default ReminderTile;
